import { render, staticRenderFns } from "./BookingResidencyProof.vue?vue&type=template&id=5f8491a5&scoped=true"
import script from "./BookingResidencyProof.vue?vue&type=script&lang=js"
export * from "./BookingResidencyProof.vue?vue&type=script&lang=js"
import style0 from "./BookingResidencyProof.vue?vue&type=style&index=0&id=5f8491a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8491a5",
  null
  
)

export default component.exports